import { GoMotoComponent } from '../../../API/GoMoto.types';
import { BaseLink } from '../BaseLink/BaseLink';
import { LinkProps } from './Link.types';

/**
 * This control handles making text into hyperlinks with options to customize what the end result is.
 *
 * @param children - {@link BaseLinkProps children} description.
 * @param props - {@link BaseLinkProps props} description.
 */
const Link: GoMotoComponent<LinkProps> = ({
    href,
    ariaLabel,
    children,
    ...props
}) => {
    return (
        <BaseLink
            href={href}
            aria-label={ariaLabel}
            {...props}
        >
            {children}
        </BaseLink>
    );
};

export default Link;